export default __webpack_public_path__ + "static/media/down-arrow-icon.64968cf7.svg";